// API routes of the app

export const BASE_URL_UAT =
  'https://hd8f04xrbc.execute-api.eu-west-1.amazonaws.com/uat';

export const BASE_URL_PROD =
  'https://7by47hhrnk.execute-api.eu-west-1.amazonaws.com/production';

export const BASE_URL = (() => {
  switch (import.meta.env.MODE) {
    case 'development':
      return ''; // Local development
    case 'dev':
      return 'https://ar2uv78oq3.execute-api.eu-west-1.amazonaws.com/dev';
    case 'uat':
      return BASE_URL_UAT;
    case 'production':
      return BASE_URL_PROD;
    default:
      return 'https://ar2uv78oq3.execute-api.eu-west-1.amazonaws.com/dev';
  }
})();

/* Marketting */
export const CANNED_PARAMETERES =
  import.meta.env.VITE_API_URL_CANNED_PARAMETERS ||
  '/api/marketing/content/v1/canned-params';

export const CANNED_PARAMETERES_BRANDS =
  import.meta.env.VITE_API_URL_CANNED_PARAMETERS_BRANDS ||
  '/api/marketing/content/v1/brands';

export const CANNED_PARAMETERES_COUNTRIES =
  import.meta.env.VITE_API_URL_CANNED_PARAMETERS_COUNTRIES ||
  '/api/marketing/content/v1/countries';

export const CANNED_PARAMETERES_INDICATIONS =
  import.meta.env.VITE_API_URL_CANNED_PARAMETERS_INDICATIONS ||
  '/api/marketing/content/v1/indications';

export const CANNED_PARAMETERES_AUDIENCES =
  import.meta.env.VITE_API_URL_CANNED_PARAMETERS_AUDIENCES ||
  '/api/marketing/content/v1/audiences';

export const CANNED_PARAMETERES_TONES =
  import.meta.env.VITE_API_URL_CANNED_PARAMETERS_TONES ||
  '/api/marketing/content/v1/tones';

export const CANNED_PARAMETERES_PRIMARY_MESSAGES =
  import.meta.env.VITE_API_URL_CANNED_PARAMETERS_PRIMARY_MESSAGES ||
  '/api/marketing/content/v1/topics';

export const CANNED_PARAMETERES_CHANNELS =
  import.meta.env.VITE_API_URL_CANNED_PARAMETERS_CHANNELS ||
  '/api/marketing/content/v1/channels';

export const CANNED_PARAMETERES_SECTIONS =
  import.meta.env.VITE_API_URL_CANNED_PARAMETERS_SECTIONS ||
  '/api/marketing/content/v1/sections';

export const CANNED_PARAMETERES_SEGMENTS =
  import.meta.env.VITE_API_URL_CANNED_PARAMETERS_SEGMENTS ||
  '/api/marketing/content/v1/segments';

export const CANNED_PARAMETERES_PLATFORMS =
  import.meta.env.VITE_API_URL_CANNED_PARAMETERS_PLATFORMS ||
  '/api/marketing/content/v1/platforms';

export const CANNED_PARAMETERES_ACTIONS =
  import.meta.env.VITE_API_URL_CANNED_PARAMETERS_PLATFORMS ||
  '/api/marketing/content/v1/actions';

export const PREGENERATE =
  import.meta.env.VITE_API_URL_PREGENERATE ||
  '/api/marketing/content/v1/pregenerate';

export const CANNED_PARAMETERES_MODULES =
  import.meta.env.VITE_API_URL_CANNED_PARAMETERS_MODULES ||
  '/api/marketing/content/v1/email-modules';

export const GENERATE =
  import.meta.env.VITE_API_URL_GENERATE || '/api/marketing/content/v1/generate';

export const GENERATE_STATUS =
  import.meta.env.VITE_API_URL_GENERATE_STATUS ||
  '/api/marketing/content/v1/generated-content/status';

export const TRANSLATE_STATUS =
  import.meta.env.VITE_API_URL_TRANSLATE_STATUS ||
  '/api/marketing/content/v1/translated-content/status';

export const GENERATED_CONTENT_EXPORT =
  import.meta.env.VITE_API_URL_GENERATED_CONTENT_EXPORT ||
  '/api/marketing/content/v1/generated-content/export';

export const REGENERATE =
  import.meta.env.VITE_API_URL_REGENERATE ||
  '/api/marketing/content/v1/regenerate';

export const UPDATE_GENERATED_CONTENT =
  import.meta.env.VITE_API_URL_UPDATE_GENERATED_CONTENT ||
  '/api/marketing/content/v1/generated-content';

export const FEEDBACK =
  import.meta.env.VITE_API_URL_FEEDBACK || '/api/marketing/content/v1/feedback';

export const TRACK_CONTENT_COPY =
  import.meta.env.VITE_API_URL_TRACK_CONTENT_COPY ||
  '/api/marketing/content/v1/tracker/content-copy';

export const BRAND_DETAILS =
  import.meta.env.VITE_API_URL_BRAND_DETAILS ||
  '/api/marketing/content/v1/brand-details';

export const PRIMARY_MESSAGES =
  import.meta.env.VITE_API_URL_PRIMARY_MESSAGES ||
  '/api/marketing/content/v1/primary-messages';

const safeEncode = (value: string | number) =>
  value ? window.encodeURIComponent(value) : '';

export const CLAIMS_REFERENCES = (
  contentId: string,
  sessionId: string,
  action: string
): string => {
  let url = import.meta.env.VITE_API_URL_CLAIMS_REFERENCES;

  if (!url) url = '/api/marketing/content/v1/references';
  url += `/?contentId=${window.encodeURIComponent(
    contentId
  )}&sessionId=${sessionId}&action=${action}`;
  return url;
};

/* Medical */
export const MEDICAL_GENERATE_SUMMARY =
  import.meta.env.VITE_API_URL_MEDICAL_GENERATE_SUMMARY ||
  '/api/medical/content/v1/generate-summary';

export const MEDICAL_SUMMARY = (jobId: string): string => {
  let url = import.meta.env.VITE_API_URL_MEDICAL_SUMMARY;

  if (!url) url = '/api/medical/content/v1/summary/';

  url += window.encodeURIComponent(jobId);
  return url;
};

export const MEDICAL_FEEDBACK =
  import.meta.env.VITE_API_URL_MEDICAL_FEEDBACK ||
  '/api/medical/content/v1/feedback';

export const MEDICAL_FILE_UPLOAD =
  import.meta.env.VITE_API_URL_MEDICAL_FILE_UPLOAD ||
  '/api/medical/content/v1/upload-file';

export const MEDICAL_FILE_DELETE = (fileUid: string): string => {
  let url = import.meta.env.VITE_API_URL_MEDICAL_FILE_DELETE;

  if (!url) url = '/api/medical/content/v1/delete-file/';

  url += window.encodeURIComponent(fileUid);
  return url;
};

export const MEDICAL_GENERATE_FILE =
  import.meta.env.VITE_API_URL_MEDICAL_GENERATE_FILE ||
  '/api/medical/content/v1/generate-file';

export const MEDICAL_DOWNLOAD_FILE = (fileUid: string): string => {
  let url = import.meta.env.VITE_API_URL_MEDICAL_DOWNLOAD_FILE;

  if (!url) url = '/api/medical/content/v1/download-file';

  url += `?fileUid=${window.encodeURIComponent(fileUid)}`;
  return url;
};

/* translation */
export const LOCALIZATION_LANGUAGES =
  import.meta.env.VITE_API_URL_LOCALIZATION_LANGUAGES ||
  '/api/marketing/content/v1/languages';

export const LOCALIZATION_TRANSLATE =
  import.meta.env.VITE_API_URL_LOCALIZATION_TRANSLATE ||
  '/api/marketing/content/v1/translate';

/* partial regeneration */
export const PARTIAL_REGENERATE =
  import.meta.env.VITE_API_URL_PARTIAL_REGENERATE ||
  '/api/marketing/content/v1/partial-regenerate';

export const RECOMMEND_IMAGES =
  import.meta.env.VITE_API_URL_RECOMMEND_IMAGES ||
  '/api/marketing/content/v1/images/recommend';

export const GENERATE_CAPTION =
  import.meta.env.VITE_API_URL_GENERATE_CAPTION ||
  '/api/marketing/content/v1/asset/generate-caption';

export const GET_FEATURE_OUTAGE_NOTIFICATION =
  import.meta.env.VITE_FEATURE_OUTAGE_NOTIFICATION ||
  '/api/marketing/content/v1/notifications';

export const CONTENT_ASSET = (
  fileUid: string,
  action: string = '',
  paramName: 'imageId' | 'imageName' = 'imageId'
): string => {
  let url = import.meta.env.VITE_API_URL_CONTENT_ASSET;

  if (!url) url = '/api/marketing/content/v1/asset';

  url += `?${paramName}=${window.encodeURIComponent(fileUid)}`;
  if (action) {
    url += `&action=${action}`;
  }
  return url;
};

/**
 * API routes for users management
 */
export const GET_USER_INFO =
  import.meta.env.VITE_API_URL_GET_USER_INFO || '/api/auth/v1/user/info';

export const GET_USERS =
  import.meta.env.VITE_API_URL_GET_USERS || '/api/auth/v1/users';

export const UPDATE_USER_ROLE = (userId: string): string => {
  let url = import.meta.env.VITE_API_URL_UPDATE_USER_ROLE;

  if (!url) url = '/api/auth/v1/users/';

  url += window.encodeURIComponent(userId);
  return url;
};

export const CONTENT_CONFIG = (
  brandName: string,
  audienceName: string,
  channelName: string,
  action?: string,
  extendedLibraryEnabled?: boolean
) => {
  let url = import.meta.env.VITE_API_URL_CONTENT_CONFIG;

  if (!url) url = '/api/marketing/content/v1/content-config';

  url += `?brandName=${brandName}&audienceName=${audienceName}&channelName=${channelName}`;
  if (action) {
    url += `&action=${action}`;
  }
  url += `&extendedLibraryEnabled=${extendedLibraryEnabled ?? false}`;
  return url;
};

export const GET_GENERATED_CONTENT = (
  sessionId: string,
  contentSessionId: string,
  action: string,
  contentId: string,
  contentGroupId: string,
  channel?: string,
  page?: number,
  pageSize?: number,
  sort?: string
) => {
  let url = import.meta.env.VITE_API_URL_GET_GENERATED_CONTENT;
  if (!url) url = '/api/marketing/content/v1/generated-content';

  url += `?contentId=${window.encodeURIComponent(
    contentId
  )}&sessionId=${window.encodeURIComponent(
    sessionId
  )}&contentSessionId=${window.encodeURIComponent(
    contentSessionId
  )}&action=${window.encodeURIComponent(
    action
  )}&contentGroupId=${window.encodeURIComponent(contentGroupId)}`;
  if (channel) {
    url += `&channel=${window.encodeURIComponent(channel)}`;
  }
  if (page) {
    url += `&page=${window.encodeURIComponent(page)}`;
  }
  if (pageSize) {
    url += `&pageSize=${window.encodeURIComponent(pageSize)}`;
  }
  if (sort) {
    url += `&sort=${sort}`;
  }

  url += `&includes=superScripts,imagesRecommend,contentReferences,translatedContent,requestParams,contentRefData`;

  return url;
};

export const GET_TRANSLATED_CONTENT = (
  sessionId: string,
  action: string,
  contentId: string,
  languages?: string,
  contentGroupId?: string,
  channel?: string,
  page?: number,
  pageSize?: number,
  sort?: string,
  allTranslations?: boolean,
  language?: string
) => {
  let url = import.meta.env.VITE_API_URL_GET_TRANSLATED_CONTENT;
  if (!url) url = '/api/marketing/content/v1/translated-content';

  url += `?sessionId=${window.encodeURIComponent(
    sessionId
  )}&action=${window.encodeURIComponent(action)}`;

  if (contentId) {
    url += `&contentId=${window.encodeURIComponent(contentId)}`;
  }

  if (contentGroupId) {
    url += `&contentGroupId=${window.encodeURIComponent(contentGroupId)}`;
  }

  if (page) {
    url += `&page=${window.encodeURIComponent(page)}`;
  }

  if (pageSize) {
    url += `&pageSize=${window.encodeURIComponent(pageSize)}`;
  }

  if (channel) {
    url += `&channel=${window.encodeURIComponent(channel)}`;
  }

  // Support both language and languages parameters with correct query parameter names
  if (language) {
    url += `&language=${window.encodeURIComponent(language)}`;
  } else if (languages) {
    url += `&languages=${window.encodeURIComponent(languages)}`;
  }

  if (sort) {
    url += `&sort=${sort}`;
  }

  if (allTranslations) {
    url += `&allTranslations=${allTranslations}`;
  }

  return url;
};

export const GET_GENERATED_CONTENT_STATUS = (
  sessionId: string,
  action: string,
  contentId: string,
  contentGroupId?: string
) => {
  let url = GENERATE_STATUS;
  url += `?contentId=${window.encodeURIComponent(
    contentId
  )}&sessionId=${window.encodeURIComponent(
    sessionId
  )}&action=${window.encodeURIComponent(action)}`;

  if (contentGroupId) {
    url += `&contentGroupId=${contentGroupId}`;
  }
  return url;
};

export const GET_TRANSLATED_CONTENT_STATUS = (
  sessionId: string,
  action: string,
  contentId: string,
  language: string,
  contentGroupId?: string
) => {
  let url = TRANSLATE_STATUS;

  url += `?contentId=${window.encodeURIComponent(
    contentId
  )}&sessionId=${window.encodeURIComponent(
    sessionId
  )}&action=${window.encodeURIComponent(
    action
  )}&language=${window.encodeURIComponent(language)}`;

  if (contentGroupId) {
    url += `&contentGroupId=${window.encodeURIComponent(contentGroupId)}`;
  }
  return url;
};

export const GET_GENERATED_CONTENT_EXPORT = (
  sessionId: string,
  action: string,
  contentId: string,
  type: string,
  language?: string,
  contentGroupId?: string,
  sort?: string[],
  languages?: string,
  allTranslations?: boolean
) => {
  let url = GENERATED_CONTENT_EXPORT;
  url += `?contentId=${window.encodeURIComponent(
    contentId
  )}&sessionId=${window.encodeURIComponent(
    sessionId
  )}&action=${window.encodeURIComponent(
    action
  )}&type=${window.encodeURIComponent(type)}`;

  if (language) {
    url += `&language=${window.encodeURIComponent(language)}`;
  }
  if (contentGroupId) {
    url += `&contentGroupId=${window.encodeURIComponent(contentGroupId)}`;
  }

  const sortEncoded = Array.isArray(sort) ? safeEncode(sort.join(',')) : '';

  if (sort && sort?.length > 0) {
    url += `&sort=${sortEncoded}`;
  }

  if (languages) {
    url += `&languages=${window.encodeURIComponent(languages)}`;
  }

  if (allTranslations) {
    url += `&allTranslations=${allTranslations}`;
  }

  return url;
};

export const GET_GENERATED_CONTENT_PREVIEW = (
  sessionId: string,
  action: string,
  contentId: string,
  contentGroupId?: string,
  channel?: string,
  contentSessionId?: string,
  requestedContentsData?: string
) => {
  let url = import.meta.env.VITE_API_URL_GENERATED_CONTENT_PREVIEW;
  if (!url) url = '/api/marketing/content/v1/generated-content/preview';

  url += `?contentId=${window.encodeURIComponent(
    contentId
  )}&sessionId=${window.encodeURIComponent(
    sessionId
  )}&action=${window.encodeURIComponent(action)}`;

  if (contentGroupId) {
    url += `&contentGroupId=${window.encodeURIComponent(contentGroupId)}`;
  }
  if (contentSessionId) {
    url += `&contentSessionId=${window.encodeURIComponent(contentSessionId)}`;
  }
  if (requestedContentsData) {
    url += `&requestedContentsData=${window.encodeURIComponent(
      requestedContentsData
    )}`;
  }
  if (channel) {
    url += `&channel=${window.encodeURIComponent(channel)}`;
  }

  return url;
};

export const GET_BRAND_DETAILS = (
  countryName: string,
  brandName: string,
  indications?: (string | undefined)[],
  audiences?: (string | undefined)[],
  includes?: (string | undefined)[],
  claimSource?: string
) => {
  let url = import.meta.env.VITE_API_URL_BRAND_DETAILS;
  if (!url) {
    url = '/api/marketing/content/v1/brand-details';
  }

  const audiencesEncoded = Array.isArray(audiences)
    ? safeEncode(audiences.join(','))
    : '';

  const indicationsEncoded = Array.isArray(indications)
    ? safeEncode(indications.join(','))
    : '';

  const includesEncoded = Array.isArray(includes)
    ? safeEncode(includes.join(','))
    : '';

  const params = [];

  params.push(`countryName=${safeEncode(countryName)}`);
  params.push(`brandName=${safeEncode(brandName)}`);

  if (indicationsEncoded) params.push(`indications=${indicationsEncoded}`);
  if (audiencesEncoded && audiencesEncoded != null)
    params.push(`audiences=${audiencesEncoded}`);
  if (includes && includes != null) params.push(`includes=${includesEncoded}`);
  if (claimSource && claimSource != null)
    params.push(`claimSource=${safeEncode(claimSource)}`);

  if (params.length > 0) {
    url += `?${params.join('&')}`;
  }

  return url;
};

export const GET_USER_SESSION_CONTEXT = (
  sessionId: string,
  includes?: string[]
) => {
  let url = `/api/marketing/content/v1/user/session/${sessionId}/context`;

  const includesEncoded = Array.isArray(includes)
    ? safeEncode(includes.join(','))
    : '';

  const params = [];

  if (includes && includes != null && includes?.length > 0) {
    params.push(`includes=${includesEncoded}`);
  }

  if (params.length > 0) {
    url += `?${params.join('&')}`;
  }

  return url;
};

export const SAVE_USER_SESSION_CONTEXT = (sessionId: string) => {
  const url = `/api/marketing/content/v1/user/session/${sessionId}/context`;

  return url;
};

export const GET_PRIMARY_MESSAGES = (
  countryName: string,
  brandName: string,
  indications?: (string | undefined)[],
  audiences?: (string | undefined)[]
) => {
  let url = import.meta.env.VITE_API_URL_PRIMARY_MESSAGES;
  if (!url) {
    url = '/api/marketing/content/v1/primary-messages';
  }

  const audiencesEncoded = Array.isArray(audiences)
    ? safeEncode(audiences.join(','))
    : '';

  const indicationsEncoded = Array.isArray(indications)
    ? safeEncode(indications.join(','))
    : '';

  const params = [];

  params.push(`countryName=${safeEncode(countryName)}`);
  params.push(`brandName=${safeEncode(brandName)}`);

  if (indicationsEncoded) params.push(`indications=${indicationsEncoded}`);
  if (audiencesEncoded && audiencesEncoded != null)
    params.push(`audiences=${audiencesEncoded}`);

  if (params.length > 0) {
    url += `?${params.join('&')}`;
  }

  return url;
};

/**
 * WF Integration
 */
export const WF_TASK_DETAILS = (taskId: string, projectId: string) => {
  let url = import.meta.env.VITE_API_URL_WF_TASK_DETAILS;
  if (!url) url = '/api/marketing/content/v1/task-details';

  url += `?taskId=${window.encodeURIComponent(
    taskId
  )}&projectId=${window.encodeURIComponent(projectId)}`;

  return url;
};

export const GET_EXTRACTION_DETAILS = (
  sessionId: string,
  fileIds: string[]
) => {
  let url = import.meta.env.VITE_API_URL_GET_EXTRACTION_DETAILS;
  if (!url) url = '/api/marketing/content/v1/file/extraction-details';

  url += `?sessionId=${sessionId}`;

  const fileIdsEncoded = fileIds
    .map(id => window.encodeURIComponent(id))
    .join(',');
  url += `&fileIds=${fileIdsEncoded}`;

  return url;
};

/**
 * file uploads and file processings
 */

export const FILE_UPLOAD =
  import.meta.env.VITE_API_URL_FILE_UPLOAD ||
  '/api/marketing/content/v1/file/upload';

export const FILE_PROCESS =
  import.meta.env.VITE_API_URL_FILE_PROCESS ||
  '/api/marketing/content/v1/file/process';

export const FILE_PROCESS_STATUS = (sessionId: string, fileIds?: string[]) => {
  let url = import.meta.env.VITE_API_URL_FILE_PROCESS_STATUS;
  if (!url) url = '/api/marketing/content/v1/file/process/status';

  url += `?sessionId=${sessionId}`;

  if (fileIds && fileIds.length > 0) {
    const fileIdsEncoded = fileIds
      .map(id => window.encodeURIComponent(id))
      .join(',');
    url += `&fileIds=${fileIdsEncoded}`;
  }

  return url;
};

export const FILE_DELETE = (
  sessionId: string,
  fileIds?: string[],
  fileName?: string
) => {
  let url = import.meta.env.VITE_API_URL_FILE_DELETE;
  if (!url) url = '/api/marketing/content/v1/file/delete';

  url += `?sessionId=${sessionId}`;

  if (fileIds && fileIds.length > 0) {
    const fileIdsEncoded = fileIds
      .map(id => window.encodeURIComponent(id))
      .join(',');
    url += `&fileIds=${fileIdsEncoded}`;
  }

  if (fileName) {
    url += `&fileName=${window.encodeURIComponent(fileName)}`;
  }

  return url;
};

export const FILE_EXCTRACTION_DETAILS =
  import.meta.env.VITE_API_URL_FILE_EXCTRACTION_DETAILS ||
  '/api/marketing/content/v1/file/extraction-details';

export const FILE_REPOSITORY = (sessionId: string) => {
  let url = import.meta.env.VITE_API_URL_FILE_REPOSITORY;
  if (!url) url = '/api/marketing/content/v1/file/repository';

  url += `?sessionId=${sessionId}`;

  return url;
};

export const FILE_UPDATE =
  import.meta.env.VITE_API_URL_FILE_UPDATE ||
  '/api/marketing/content/v1/file/update';

export const FILE_DOWNLOAD = (sessionId: string, fileIds: string[]) => {
  let url = import.meta.env.VITE_API_URL_FILE_DOWNLOAD;
  if (!url) url = '/api/marketing/content/v1/file/download';

  url += `?sessionId=${sessionId}`;

  if (fileIds && fileIds.length > 0) {
    const fileIdsEncoded = fileIds
      .map(id => window.encodeURIComponent(id))
      .join(',');
    url += `&fileIds=${fileIdsEncoded}`;
  }

  return url;
};

/**
 *
 * user
 */

export const USER_SESSION =
  import.meta.env.VITE_API_URL_USER_SESSION ||
  '/api/marketing/content/v1/user/session';
export const GET_USER_SESSION_URL = (): string => {
  const url = USER_SESSION;
  return `${url}`;
};

export const GET_FILE_UPLOAD_PRESIGNED = () => {
  const url = import.meta.env.VITE_API_URL_PRESIGNED;
  if (!url) return 'https://presigned/file_upload_test_2.pdf';
  return url;
};

export const SUPPORTING_INFORMATION =
  import.meta.env.VITE_API_URL_SUPPORTING_INFORMATION ||
  '/api/marketing/content/v1/supporting-info';

export const GENERATED_CONTENT_VALIDATION =
  import.meta.env.VITE_API_URL_GENERATED_CONTENT_VALIDATION ||
  '/api/marketing/content/v1/generated-content/validation';

export const GENERATED_CONTENT_VALIDATION_STATUS =
  import.meta.env.VITE_API_URL_GENERATED_CONTENT_VALIDATION_STATUS ||
  '/api/marketing/content/v1/generated-content/validation/status';

export const GENERATED_CONTENT_VALIDATION_RESULTS =
  import.meta.env.VITE_API_URL_GENERATED_CONTENT_VALIDATION_RESULTS ||
  '/api/marketing/content/v1/generated-content/validation';

export const GET_SEGMENT_DETAILS = (
  brandName: string,
  audiences?: (string | undefined)[],
  countryName?: string,
  indications?: (string | undefined)[]
) => {
  const audiencesEncoded = Array.isArray(audiences)
    ? safeEncode(audiences.join(','))
    : '';

  const indicationsEncoded = Array.isArray(indications)
    ? safeEncode(indications.join(','))
    : '';

  let url = import.meta.env.VITE_API_SEGMENT_DETAILS;
  if (!url) url = '/api/marketing/content/v1/segment-details';

  url += `?brandName=${safeEncode(brandName)}`;
  if (audiencesEncoded) {
    url += `&audiences=${audiencesEncoded}`;
  }
  if (countryName) {
    url += `&countryName=${safeEncode(countryName)}`;
  }
  if (indicationsEncoded) {
    url += `&indications=${indicationsEncoded}`;
  }

  return url;
};

export const GET_CLAIM_DETAILS = ({
  countryName,
  brandName,
  indications,
  audiences,
  primaryMessages,
  languages,
  aboveMarketTeams,
  pageSize = 20,
  page = 1,
}: {
  countryName: string;
  brandName: string;
  indications?: (string | undefined)[];
  audiences?: (string | undefined)[];
  primaryMessages?: (string | undefined)[];
  languages?: (string | undefined)[];
  aboveMarketTeams?: (string | undefined)[];
  pageSize?: number;
  page?: number;
}) => {
  let url = import.meta.env.VITE_API_SEGMENT_DETAILS;
  if (!url) url = '/api/marketing/content/v1/claim-details';

  const audiencesEncoded = Array.isArray(audiences)
    ? safeEncode(audiences.join(','))
    : '';

  const indicationsEncoded = Array.isArray(indications)
    ? safeEncode(indications.join(','))
    : '';

  const primaryMessagesEncoded = Array.isArray(primaryMessages)
    ? safeEncode(primaryMessages.join(','))
    : '';

  const languagesEncoded = Array.isArray(languages)
    ? safeEncode(languages.join(','))
    : '';

  const aboveMarketTeamsEncoded = Array.isArray(aboveMarketTeams)
    ? safeEncode(aboveMarketTeams.join(','))
    : '';

  // Start building the query string
  const params = [];

  if (countryName) params.push(`countryName=${safeEncode(countryName)}`);
  if (brandName) params.push(`brandName=${safeEncode(brandName)}`);
  if (indicationsEncoded) params.push(`indications=${indicationsEncoded}`);
  if (audiencesEncoded) params.push(`audiences=${audiencesEncoded}`);
  if (primaryMessagesEncoded)
    params.push(`primaryMessages=${primaryMessagesEncoded}`);
  if (languagesEncoded) params.push(`languages=${languagesEncoded}`);
  if (aboveMarketTeamsEncoded)
    params.push(`aboveMarketTeams=${aboveMarketTeamsEncoded}`);
  if (page) params.push(`page=${safeEncode(page)}`);
  if (pageSize) params.push(`pageSize=${safeEncode(pageSize)}`);

  // Append query string if there are valid parameters
  if (params.length > 0) {
    url += `?${params.join('&')}`;
  }

  return url;
};

export const GET_IMAGES = ({
  countryName,
  brandName,
  indications,
  nextPageToken = '',
  audienceNames,
  page,
  pageSize,
}: {
  countryName: string;
  brandName: string;
  indications?: (string | undefined)[];
  nextPageToken?: string | null;
  audienceNames?: string | string[];
  page?: number;
  pageSize?: number;
}) => {
  let url = import.meta.env.VITE_API_IMAGES;
  if (!url) url = '/api/marketing/content/v1/images';

  const indicationsEncoded = Array.isArray(indications)
    ? safeEncode(indications.join(','))
    : '';

  // Start building the query string
  const params = [];

  if (countryName) params.push(`countryName=${safeEncode(countryName)}`);
  if (brandName) params.push(`brandName=${safeEncode(brandName)}`);
  if (indicationsEncoded) params.push(`indications=${indicationsEncoded}`);
  if (nextPageToken) params.push(`nextPageToken=${safeEncode(nextPageToken)}`);
  if (audienceNames) {
    const audienceNamesEncoded = Array.isArray(audienceNames)
      ? safeEncode(audienceNames.join(','))
      : safeEncode(audienceNames);
    params.push(`audienceNames=${audienceNamesEncoded}`);
  }
  if (page) params.push(`page=${safeEncode(page)}`);
  if (pageSize) params.push(`pageSize=${safeEncode(pageSize)}`);

  // Append query string if there are valid parameters
  if (params.length > 0) {
    url += `?${params.join('&')}`;
  }

  return url;
};

export const DOWNLOAD_IMAGES = ({
  brandName,
  countryName,
  indications,
  audienceNames,
  eventId,
}: {
  countryName: string;
  brandName: string;
  indications?: (string | undefined)[];
  audienceNames?: string[];
  eventId?: string;
}) => {
  let url = import.meta.env.VITE_API_IMAGES_DOWNLOAD;
  if (!url) url = '/api/marketing/content/v1/images/download';

  const indicationsEncoded = Array.isArray(indications)
    ? safeEncode(indications.join(','))
    : '';

  const params = [];
  if (countryName) params.push(`countryName=${safeEncode(countryName)}`);
  if (brandName) params.push(`brandName=${safeEncode(brandName)}`);
  if (indicationsEncoded) params.push(`indications=${indicationsEncoded}`);
  if (audienceNames && audienceNames.length > 0) {
    const audienceNamesEncoded = safeEncode(audienceNames.join(','));
    params.push(`audienceNames=${audienceNamesEncoded}`);
  }
  if (eventId) {
    params.push(`eventId=${safeEncode(eventId)}`);
  }
  if (params.length > 0) {
    url += `?${params.join('&')}`;
  }

  return url;
};
/* Image Generation */
export const IMAGE_PROMPT_GENERATE =
  import.meta.env.VITE_API_URL_IMAGE_PROMPT_GENERATE ||
  '/api/marketing/content/v1/image/prompt/generate';

export const IMAGE_GENERATE =
  import.meta.env.VITE_API_URL_IMAGE_GENERATE ||
  '/api/marketing/content/v1/image/generate';

// version info
export const GET_VERSION_INFO =
  import.meta.env.VITE_API_URL_GET_VERSION_INFO ||
  '/api/marketing/content/v1/application-config';

export const GET_CLAIM_DETAILS_METADATA = ({
  countryName,
  brandName,
  indications,
  audiences,
  primaryMessages,
  includes,
}: {
  countryName: string;
  brandName: string;
  indications?: (string | undefined)[];
  audiences?: (string | undefined)[];
  primaryMessages?: (string | undefined)[];
  includes?: (string | undefined)[];
}) => {
  let url = import.meta.env.VITE_API_URL_CLAIM_DETAILS_METADATA;
  if (!url) url = '/api/marketing/content/v1/claim-details/facets';

  const audiencesEncoded = Array.isArray(audiences)
    ? safeEncode(audiences.join(','))
    : '';

  const indicationsEncoded = Array.isArray(indications)
    ? safeEncode(indications.join(','))
    : '';

  const primaryMessagesEncoded = Array.isArray(primaryMessages)
    ? safeEncode(primaryMessages.join(','))
    : '';

  const includesEncoded = Array.isArray(includes)
    ? safeEncode(includes.join(','))
    : '';

  // Start building the query string
  const params = [];

  if (countryName) params.push(`countryName=${safeEncode(countryName)}`);
  if (brandName) params.push(`brandName=${safeEncode(brandName)}`);
  if (indicationsEncoded) params.push(`indications=${indicationsEncoded}`);
  if (audiencesEncoded) params.push(`audiences=${audiencesEncoded}`);
  if (primaryMessagesEncoded)
    params.push(`primaryMessages=${primaryMessagesEncoded}`);
  if (includesEncoded) params.push(`includes=${includesEncoded}`);

  // Append query string if there are valid parameters
  if (params.length > 0) {
    url += `?${params.join('&')}`;
  }

  return url;
};

/**
 * Content Rules Center APIs
 */
export const CONTENT_RULES_CATEGORIES =
  import.meta.env.VITE_API_URL_CONTENT_RULES_CATEGORIES ||
  '/api/marketing/content/v1/content-rules/metadata/categories';

export const CONTENT_RULES_SEVERITY_SUMMARY =
  import.meta.env.VITE_API_URL_CONTENT_RULES_SEVERITY_SUMMARY ||
  '/api/marketing/content/v1/content-rules/summary/severity-wise';

export const CONTENT_RULES_CATEGORY_SUMMARY =
  import.meta.env.VITE_API_URL_CONTENT_RULES_CATEGORY_SUMMARY ||
  '/api/marketing/content/v1/content-rules/summary/category-wise';

export const CONTENT_RULES =
  import.meta.env.VITE_API_URL_CONTENT_RULES ||
  '/api/marketing/content/v1/content-rules/rules';

export const GET_CONTENT_RULES = ({
  countries,
  brands,
  audience,
  channels,
  categories,
  page = 1,
  pageSize = 20,
}: {
  countries?: string;
  brands?: string;
  audience?: string;
  channels?: string;
  categories?: string;
  page?: number;
  pageSize?: number;
}) => {
  let url = CONTENT_RULES;

  const params = [];

  if (countries) params.push(`countries=${safeEncode(countries)}`);
  if (brands) params.push(`brands=${safeEncode(brands)}`);
  if (audience) params.push(`audience=${safeEncode(audience)}`);
  if (channels) params.push(`channels=${safeEncode(channels)}`);
  if (categories) params.push(`categories=${safeEncode(categories)}`);
  if (page) params.push(`page=${safeEncode(page)}`);
  if (pageSize) params.push(`pageSize=${safeEncode(pageSize)}`);

  if (params.length > 0) {
    url += `?${params.join('&')}`;
  }

  return url;
};
